<script setup lang="ts">
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip.vue'
import NumberInput from '@/components/lib/NumberInput.vue'

export interface Props {
  conf: any
  handDetails: any
  players: Array<any>
  hasBountyInstant: boolean
  hasBountyTotal: boolean
}

defineProps<Props>()

const emit = defineEmits(['update:stack'])
</script>

<template>
  <div
    v-for="ii in [
      {
        key: 'stack',
        confPart: conf.stack,
        keys: players.map(p => `stack_${p.position.replace('+', '')}`),
      },
      hasBountyInstant && {
        key: 'bounty_instant',
        confPart: conf.bounty_instant,
        keys: players.map(i => `bounty_instant_${i.position.replace('+', '')}`),
      },
      hasBountyTotal && {
        key: 'bounty_total',
        confPart: conf.bounty_total,
        keys: players.map(i => `bounty_total_${i.position.replace('+', '')}`),
      },
    ].filter(Boolean) as any[]"
    :key="ii.key"
    class="f-column mr-auto"
  >
    <GwTitleTooltip
      :title="$t(`solfigr.icm.${ii.key}`)"
      :tooltip="$t(`solfigr.icm.${ii.key}_tooltip`)"
      style="margin: 0 0 0.25rem 0"
    />
    <div
      class="d-flex gw_box f-wrap"
      style="gap: 0.5rem; --clr-box-back: var(--clr-black-1-2); --box-padding: 0.5rem"
    >
      <div
        v-for="key in ii.keys"
        :key="key"
        class="f-column flex-1"
        style="gap: 0.5rem; min-width: 13.75rem"
        :data-tst="key"
      >
        <div class="clr-grey weight_500 text-medium my-auto solfigricmhdtls_valtitle">
          <span
            class="mdi"
            :class="key.split('_').pop() === 'OOP' ? 'mdi-account' : 'mdi-account-outline'"
          ></span>
          {{
            players.find(p => p.position.replace(/^(\D+)(\d+)$/, '$1+$2') === key.split('_').pop())
              ?.display_position
          }}
        </div>

        <div class="f-center position-relative flex-1">
          <div class="f-center mb-auto w-100">
            <NumberInput
              class="flex-1"
              style="--input-width: 100%"
              :tabindex="ii.disabled ? -1 : 0"
              :min="ii.confPart.min"
              :max="ii.confPart.max"
              :step="ii.confPart.step"
              :decimals="ii.confPart.decimals"
              :inputmode="ii.confPart.inputmode"
              :hasMinus="false"
              :hasPlus="false"
              :hasWheelScroll="false"
              :value="handDetails[key]"
              :style="
                handDetails?.errors
                  ? handDetails?.errors[`error_${key}`]
                    ? '--clr-focus: var(--clr-error);--clr-outline:var(--clr-error);'
                    : ''
                  : ''
              "
              @input="value => emit('update:stack', { key, value })"
            />

            <div
              class="clr-grey weight_500 text-medium"
              style="position: absolute; right: 0.5rem; z-index: 8"
            >
              {{ ii.confPart.unit }}
            </div>
          </div>
        </div>
        <div
          v-if="handDetails?.errors?.[`error_${key}`]"
          style="max-width: 13rem"
          :data-tst="`solfigr_${key}_error`"
          class="solfigrstpot_errormessage mb-auto"
        >
          <div class="clr-error text-small f-align-center no-shrink">
            {{
              $t('solfigr.stackpot.error_stackpot_ratio', {
                ratio: conf.stack.flop_stackPotRatioValue,
              })
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.solfigricmhdtls_valtitle {
  display: none;
}
@media screen and (max-width: 608px) {
  .solfigricmhdtls_valtitle {
    display: block;
  }
}
</style>
